"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialStateScript = exports.getInitialState = exports.INITIAL_STATE_SCRIPT_NAME = void 0;
const react_1 = __importDefault(require("react"));
const window_1 = require("../../../utils/window");
exports.INITIAL_STATE_SCRIPT_NAME = '__INITIAL_STATE__';
const getInitialState = (name) => (0, window_1.isClientSide)() ? window[name ? name : exports.INITIAL_STATE_SCRIPT_NAME] : undefined;
exports.getInitialState = getInitialState;
const InitialStateScript = (props) => {
    const { name = exports.INITIAL_STATE_SCRIPT_NAME, initialState } = props;
    const INITIAL_STATE = encodeURIComponent(JSON.stringify(initialState));
    const innerHTML = `window.${name} = JSON.parse(decodeURIComponent("${INITIAL_STATE}"));`;
    return (react_1.default.createElement("script", { dangerouslySetInnerHTML: {
            __html: innerHTML
        } }));
};
exports.InitialStateScript = InitialStateScript;
